import { useContext } from 'react';
import SnackbarContext, { ISnackbarContext } from 'src/contexts/SnackbarContext';

const useSnackbar = (): ISnackbarContext => useContext(SnackbarContext);

export default useSnackbar;

